import * as Sentry from '@sentry/capacitor';
import * as SentryVue from '@sentry/vue';
import { Capacitor } from '@capacitor/core';
import { APP_ID, APP_VERSION } from '@/config/version';

/**
 * Initialize Sentry for error tracking
 * @param {object} options - Configuration options
 * @param {object} options.app - Vue app instance
 * @param {object} options.router - Vue router instance
 */
export const initSentry = ({ app, router }) => {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.warn('Sentry DSN not configured, skipping initialization');

    return;
  }

  const platform = Capacitor.getPlatform();

  Sentry.init(
    {
      app,
      dsn,
      release: `${APP_ID}@${APP_VERSION}`,
      environment: Capacitor.isNativePlatform() ? 'production' : 'development',
      integrations: [
        SentryVue.browserTracingIntegration({ router }),
      ],
      initialScope: {
        tags: {
          platform,
        },
      },
    },
    SentryVue.init,
  );
};

/**
 * Set user context for Sentry error tracking
 */
export const setSentryUser = (userId) => {
  if (userId) {
    Sentry.setUser({ id: String(userId) });
  }
};

/**
 * Clear user context (on logout)
 */
export const clearSentryUser = () => {
  Sentry.setUser(null);
};

export { Sentry };
